import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchCallLogTypes(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('appointment/call-log-types', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteCallLogType(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`appointment/call-log-types/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
